import ThreadList from './ThreadList'

export default {
  ThreadList
}
